import { Row } from 'antd';
import { FC } from 'react';

import {
  AdyenAssign,
  AdyenRefusedTransaction,
  AdyenTransaction,
  ClientType,
  HotmartSubscriptionItemResponse,
  HotmartTransactionItemResponse,
  ItunesResponse,
  PagarMeSubscription,
  PagarMeTransaction,
} from 'src/features/clients/types/clientTypes';

import { AdyenTableComponent } from './AdyenTableComponent';
import { HotmartTableComponent } from './HotmartTableComponent';
import { ItunesComponent } from './ItunesComponent';
import { PagarMeTableComponent } from './PagarMeTableComponent';

export type CustomerLegacyTransactionsSectionProps = {
  dados?: ClientType;
  subscriptionsPagarme?: PagarMeSubscription[];
  transactionsPagarme?: PagarMeTransaction[];
  assignHotmart?: HotmartSubscriptionItemResponse[];
  transactionsHotmart?: HotmartTransactionItemResponse[];
  assignAdyen?: AdyenAssign[];
  transactionsAdyen?: AdyenTransaction[];
  refundAdyen?: AdyenTransaction[];
  transactionsCancelation?: AdyenRefusedTransaction[];
  transactionsItunes?: ItunesResponse[];
};

export const CustomerLegacyTransactionsSection: FC<
  CustomerLegacyTransactionsSectionProps
> = ({
  dados,
  subscriptionsPagarme,
  transactionsPagarme,
  assignHotmart,
  transactionsHotmart,
  assignAdyen,
  transactionsAdyen,
  refundAdyen,
  transactionsCancelation,
  transactionsItunes,
}) => {
  return (
    <Row>
      <PagarMeTableComponent
        subscriptionsPagarme={subscriptionsPagarme || []}
        transactionsPagarme={transactionsPagarme || []}
      />
      <HotmartTableComponent
        assignHotmart={assignHotmart || []}
        transactionsHotmart={transactionsHotmart || []}
      />
      <AdyenTableComponent
        dados={dados}
        assignAdyen={assignAdyen}
        transactionsAdyen={transactionsAdyen}
        refundAdyen={refundAdyen}
        transactionsCancelation={transactionsCancelation}
      />
      <ItunesComponent transactionsItunes={transactionsItunes} />
    </Row>
  );
};
